import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=06dcfab6&"
import script from "./VendorCard.vue?vue&type=script&lang=js&"
export * from "./VendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06dcfab6')) {
      api.createRecord('06dcfab6', component.options)
    } else {
      api.reload('06dcfab6', component.options)
    }
    module.hot.accept("./VendorCard.vue?vue&type=template&id=06dcfab6&", function () {
      api.rerender('06dcfab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/vendor-partners/cards/VendorCard.vue"
export default component.exports